export type CityKey = 'djerba' | 'zarzis' | 'hammamet' | 'tunis' | 'sousse'

export const CITY_KEYS: Array<CityKey> = ['djerba', 'zarzis', 'hammamet', 'tunis', 'sousse']

export const CITY_DEFAULT_REGION: Record<CityKey, string> = {
    djerba: 'Médenine',
    zarzis: 'Médenine',
    hammamet: 'Nabeul',
    tunis: 'Tunis',
    sousse: 'Sousse'
}

export const CITY_LABELS: Record<CityKey, { en: string, de: string, fr: string, ar: string }> = {
    djerba: { en: 'Djerba', de: 'Djerba', fr: 'Djerba', ar: 'جربة' },
    zarzis: { en: 'Zarzis', de: 'Zarzis', fr: 'Zarzis', ar: 'جرجيس' },
    hammamet: { en: 'Hammamet', de: 'Hammamet', fr: 'Hammamet', ar: 'الحمامات' },
    tunis: { en: 'Tunis (capital)', de: 'Tunis (Hauptstadt)', fr: 'Tunis (capitale)', ar: 'تونس (العاصمة)' },
    sousse: { en: 'Sousse', de: 'Sousse', fr: 'Sousse', ar: 'سوسة' }
}

const CITY_ALIASES: Record<CityKey, Array<string>> = {
    djerba: ['djerba', 'jerba', 'djerba island', 'ile de djerba', 'insel djerba', 'houmt souk', 'midoun', 'جربة', 'جزيرة جربة'],
    zarzis: ['zarzis', 'jarjis', 'جرجيس'],
    hammamet: ['hammamet', 'yasmine hammamet', 'الحمامات', 'حمامات'],
    tunis: ['tunis', 'tunis capital', 'tunis hauptstadt', 'tunis capitale', 'تونس', 'تونس العاصمة'],
    sousse: ['sousse', 'soussa', 'susa', 'سوسة', 'سوسه']
}

export const isCityKey = (value: unknown): value is CityKey =>
    typeof value === 'string' && (CITY_KEYS as Array<string>).includes(value)

export const normalizeCityText = (value: string): string =>
    value
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[()]/g, ' ')
        .replace(/[-_,.]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()

export const matchCity = (value: string): CityKey | null => {
    const normalized = normalizeCityText(value)

    if (!normalized) return null

    for (const key of CITY_KEYS) {
        const labels = Object.values(CITY_LABELS[key]).map(normalizeCityText)
        const aliases = CITY_ALIASES[key].map(normalizeCityText)

        if (labels.includes(normalized) || aliases.includes(normalized)) return key
    }

    return null
}

export const filterCities = (value: string): Array<CityKey> => {
    const normalized = normalizeCityText(value)

    if (!normalized) return CITY_KEYS

    return CITY_KEYS.filter(key => {
        const candidates = [...Object.values(CITY_LABELS[key]), ...CITY_ALIASES[key]].map(normalizeCityText)

        return candidates.some(candidate => candidate.includes(normalized))
    })
}
